import type { TaskEither } from 'fp-ts/lib/TaskEither';
import { fetchTE } from 'utils/request';

export const getNodepoolTE = <E = CF.API.ApiError>(
  {
    userId,
    computeClusterId,
    nodepoolId,
    params = '',
    sessionToken,
  }: { userId: string; computeClusterId: string; nodepoolId: string; params?: string; sessionToken?: string },
  onRejected?: (e: CF.API.ApiError) => E,
): TaskEither<E, CF.API.Compute.GetNodePoolResponse> =>
  fetchTE<CF.API.Compute.GetNodePoolResponse, E>(
    {
      path: `/api/_api/v2${userId ? `/users/${userId}` : ''}/compute_clusters/${computeClusterId}/nodepools/${nodepoolId}${
        params ? `?${params}` : ''
      }`,
      method: 'GET',
      sessionToken,
    },
    onRejected,
  );
